import api from "./axios";

export const documentsApi = {
  uploadAadhaar: async (formData) => {
    const res = await api.post("/api/kyc/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  uploadKycFormData: async (formData) => {
    const res = await api.post("/api/kyc/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  uploadAadhaarManual: async ({ aadhaarNumber, frontImage, backImage }) => {
    const formData = new FormData();
    formData.append("aadhaarNumber", aadhaarNumber);
    formData.append("frontImage", frontImage);
    formData.append("backImage", backImage);

    const res = await api.post("/aadhaar/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  },
};
